module.exports = __webpack_public_path__ + "img/hd3.c72375ee.png";